module.exports = __webpack_public_path__ + "img/myVip_kefu_new.4294e462.png";